module.exports = __webpack_public_path__ + "media/Ringtone2.d8b93915.mp3";